const formatMoney = (amount, currency, locale) => {
    const localeToUse = ['de-AT', 'de-CH'].includes(locale)
        ? 'de-DE'
        : ['it-IT'].includes(locale)
            ? 'de-AT'
            : ['da-DK'].includes(locale)
                ? 'nb-NO'
                : locale;
    const currencyToUse = locale === 'ro-RO' ? 'LEI' : locale === 'da-DK' ? 'NOK' : currency;
    const formatter = new Intl.NumberFormat(localeToUse, {
        style: 'currency',
        currency: currencyToUse,
    });
    return formatter.format(typeof amount === 'string' ? parseFloat(amount) : amount);
};
function getUrlLocalised(t, relativeUrl, elementId) {
    const localizedUrl = t('common.multilingual-locale') === 'common.multilingual-locale'
        ? relativeUrl
        : t('common.multilingual-locale') + relativeUrl;
    if (elementId) {
        return `${localizedUrl}#${elementId}`;
    }
    return localizedUrl;
}
async function getHash(message) {
    const msgUint8 = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}
function sameArticles(firstArray, secondArray) {
    return (JSON.stringify(firstArray.sort((a, b) => a.articleShopId - b.articleShopId)) ===
        JSON.stringify(secondArray.sort((a, b) => a.articleShopId - b.articleShopId)));
}

export { formatMoney, getHash, getUrlLocalised, sameArticles };
//# sourceMappingURL=utils.js.map
